import moment from 'moment'

const state = {
  devices: []
}

const mutations = {
  RESET_DEVICES: function (state) {
    state.devices = [];
  },
  SET_DEVICES: function (state, devices) {
    state.devices = devices;
  }
}

const actions = {

  initializeDevices({ commit, state, rootState }, devices) {

    return new Promise(resolve => {
      let p = [];
      let promiseArray = devices.map(dev => {
        return rootState.Database.db
          .collection("devices")
          .doc(dev)
          .get()
          .then(function (doc) {
            if (doc.exists) {
              let data = doc.data();
              data['id'] = doc.id;
              p.push(data);
            }
          })

      });
      Promise.all(promiseArray).then(() => {
        commit('SET_DEVICES', p);
        resolve(p);
      })

    })
  }
}

const getters = {
  getDevices(state) {
    if (state.devices != null) {
      return state.devices
    }
    else {
      return []
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
} 



// WEBPACK FOOTER //
// ./src/store/modules/Devices.js